import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SideDrawer from '../SideDrawer';
import { fetchMatchingConfigs } from '../../../../redux/actions/ns/onDemandScreening';

const Drawer = ({
  dispatch,
  runInstanceId,
  segmentCode,
  isOpen,
  onClose,
  visibleItem,
  matchingConfigs,
  isLoading,
  hasError,
  errorMessage
}) => {
  useEffect(() => {
    if (isOpen && matchingConfigs?.id !== runInstanceId) {
      dispatch(fetchMatchingConfigs({ runInstanceId }));
    }
  }, [runInstanceId, isOpen]);

  const segment = useMemo(() => {
    return matchingConfigs?.matchingConfigsBySegment?.[segmentCode] || {};
  }, [matchingConfigs, segmentCode]);

  return (
    <SideDrawer
      isOpen={isOpen}
      visibleItem={visibleItem}
      segment={segment}
      onClose={onClose}
      isLoading={isLoading}
      tabIds={['watchlist', 'whitelist']}
      errorMessage={hasError ? errorMessage : null}
    />
  );
};

Drawer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  runInstanceId: PropTypes.string.isRequired,
  segmentCode: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  visibleItem: PropTypes.string,
  matchingConfigs: PropTypes.array,
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string
};

const mapStateToProps = ({ nsOnDemandScreening }) => {
  const {
    matchingConfigs: { isLoading, data, hasError, errorMessage }
  } = nsOnDemandScreening;

  return {
    matchingConfigs: data,
    isLoading,
    hasError,
    errorMessage
  };
};

export default connect(mapStateToProps)(Drawer);
